/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {injectIntl, FormattedMessage} from 'react-intl';
import CommentsTableRow from './CommentsTableRow'
import ExpandableList from "../../common/ExpandableList";
import {sliceItemsFromEnd} from "../../utils/Helpers";

class CommentsTable extends React.Component {

    getCommentRow(comment) {
        //if current user does not match the creator of the comment, do not pass updateComment callback so that it is not editable
        let updateCommentCallback;
        if (comment.userId === this.props.currentUserId) {
            updateCommentCallback = this.props.updateComment
        }
        return <CommentsTableRow key={comment.id} comment={comment} updateComment={updateCommentCallback}/>
    }

    render() {
        const {comments, intl} = this.props

        const items = comments.map(c => this.getCommentRow(c))
        let emptyMessage = '';
        if (items.length === 0) {
            emptyMessage = <FormattedMessage id="fault.detail.title.comments.empty" />
        }

        const slicedCommentItems = sliceItemsFromEnd(items, 3);

        return (
            <div className="ui history-table comments-table">
                <ExpandableList content={slicedCommentItems[0]} expandedContent={slicedCommentItems[1]} expandable={slicedCommentItems[1].length > 0}
                                expandLinkText={intl.formatMessage({id: "fault.detail.comments.more"}, {count: slicedCommentItems[1].length})} />
                {emptyMessage}
            </div>
        )
    }
}

export default injectIntl(CommentsTable)